export default {
  "challenge/rated": {
    en: "Rated",
    fr: "Classé",
  },
  "challenge/casual": {
    en: "Casual",
    fr: "Amical",
  },
};
